<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span style="position:relative">
        <div id="overlay" class="overlay hidden"></div>
        <el-menu id="normalBar" class="el-menu-demo hidden-sm-and-down fixed-normal" mode="horizontal"> 
            <el-menu-item id="2x" class="normal" index="1">
              <router-link to='/'>
                Inicio
              </router-link>
            </el-menu-item>           
            <el-menu-item id="1x" class="normal" index="2">
              <router-link to='/nosotros'>
                Nosotros
              </router-link>
            </el-menu-item>
            <el-menu-item id="3x" class="normal" v-scroll-to="'#clients'"  index="3">
              <router-link to='/clientes'>
                Clientes
              </router-link>    
            </el-menu-item>
            
            <el-submenu id="4x" class="normal" index="4">
              <template id="title-submenu" slot="title">Servicios</template>
              <el-menu-item index="2-1">
                <router-link to='/servicio/soluciones-web'>
                    Soluciones
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <a target="_blank" href="https://hosting.chevere.tech/" style="text-decoration:none" >
                    Dominio y hosting
                </a>
              </el-menu-item>
              <el-menu-item index="2-3">
                <router-link to='/servicio/desarrollos-de-aplicaciones'>
                    Desarrollos
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-4">
                <router-link to='/servicio/optimizacion-de-procesos'>
                    Optimizacion
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-5">
                <router-link to='/servicio/outsourcing'>
                    Outsourcing
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-6">
                <router-link to='/servicio/facturacion'>
                    Facturación
                </router-link>
              </el-menu-item>
            </el-submenu>                      
            <el-menu-item id="5x" class="normal" v-scroll-to="'#products'"  index="5">Productos</el-menu-item>
            <el-menu-item id="7x" class="normal" v-scroll-to="'#contact'"  index="7">Contáctanos</el-menu-item>
            <router-link to='/'>
              <img style="width:3%; margin-top:5px; position:absolute; right:30px;" src="./../../public/assets/images/identidad/isotipo.png" alt="CheverTech">
            </router-link>              
        </el-menu>
        <ul id="navBar" class="navbar-respon hidden" mode="horizontal">            
            <li>
              <router-link to='/'>
                <img style="width: 15%; margin-top:5px; margin-bottom:-30px" src="./../../public/assets/images/identidad/isotipo.png" alt="CheverTech">
              </router-link>
            </li>

            <li>
              <router-link to='/nosotros'>
                Nosotros
              </router-link>
            </li>
            <li>
              <router-link to='/clientes'>
                Clientes
              </router-link>
            </li>
            <li @click="onShowSubMenu()" >Servicios</li> 
            <ul id="sub-menu" mode="horizontal" class="sub-menu hidden">
              <li class="servicios-submenu">
                </li><br>  
              <li class="servicios-submenu">
                <router-link to='/servicio/soluciones-web'>
                    Soluciones
                </router-link>
              </li><br>  
              <li class="servicios-submenu">
                <router-link to='/servicio/redes'>
                    Redes
                </router-link>
              </li><br>  
              <li class="servicios-submenu">
                <router-link to='/servicio/desarrollos-de-aplicaciones'>
                    Desarrollos
                </router-link>  
              </li><br>  
              <li class="servicios-submenu">
                <router-link to='/servicio/optimizacion-de-procesos'>
                    Optimización
                </router-link>  
              </li><br>  
              <li class="servicios-submenu">
                <router-link to='/servicio/outsourcing'>
                    Outsourcing
                </router-link>
              </li><br>  
              <li class="servicios-submenu">
                <router-link to='/servicio/facturacion'>
                    Facturación
                </router-link>
              </li><br>
            </ul>  
            <li style="cursor:pointer" v-scroll-to="'#products'" >Products</li>
            <li style="cursor:pointer" v-scroll-to="'#contact'" >Contáctanos</li>
        </ul>
        <div @click="onClick()" class="hidden-md-and-up" id="nav-icon2">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div> 
                
    </span>
</template>

<script>

export default {
    name: "navbar",
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      onClick () {
        var d = document.getElementById("nav-icon2");
        d.classList.toggle("open");
        var e = document.getElementById("overlay");
        e.classList.toggle("hidden");
        var c = document.getElementById("navBar");
        c.classList.toggle("hidden");
        c.classList.toggle("fixed");        
      },
      onShowSubMenu () {        
        var c = document.getElementById("sub-menu");
        c.classList.toggle("hidden");
      }
  }     
}
</script>

<style scoped>
    #nav-icon2{
      width: 60px;
      height: 20px;
      position: fixed;
      top: -25px;
      right: 10%;
      z-index: 1;
      margin: 50px auto;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: .5s ease-in-out;
      -moz-transition: .5s ease-in-out;
      -o-transition: .5s ease-in-out;
      transition: .5s ease-in-out;
      cursor: pointer;
    }

.servicios-submenu{
  margin-top : 15px;
  padding-left: 7px;
}

#nav-icon2 span {
  display: block;
  position: absolute;
  height: 5px;
  width: 50%;
  z-index: 2;
  background: rgb(61,142,149);
  opacity: 1;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

#nav-icon2 span:nth-child(even) {
  left: 50%;
  border-radius: 0 9px 9px 0;
}

#nav-icon2 span:nth-child(odd) {
  left:0px;
  border-radius: 9px 0 0 9px;
}

#nav-icon2 span:nth-child(1), #nav-icon2 span:nth-child(2) {
  top: 0px;
}

#nav-icon2 span:nth-child(3), #nav-icon2 span:nth-child(4) {
  top: 18px;
}

#nav-icon2 span:nth-child(5), #nav-icon2 span:nth-child(6) {
  top: 36px;
}

#nav-icon2.open span:nth-child(1),#nav-icon2.open span:nth-child(6) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#nav-icon2.open span:nth-child(2),#nav-icon2.open span:nth-child(5) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#nav-icon2.open span:nth-child(1) {
  left: 5px;
  top: 7px;
}

#nav-icon2.open span:nth-child(2) {
  left: calc(50% - 5px);
  top: 7px;
}

#nav-icon2.open span:nth-child(3) {
  left: -50%;
  opacity: 0;
}

#nav-icon2.open span:nth-child(4) {
  left: 100%;
  opacity: 0;
}

#nav-icon2.open span:nth-child(5) {
  left: 5px;
  top: 29px;
}

#nav-icon2.open span:nth-child(6) {
  left: calc(50% - 5px);
  top: 29px;
}

.hidden{
  display:none;
} 

.fixed{
  position: fixed;
  top: -50px;
  left: 0px;
  z-index: 10;
  margin: 50px auto;
  width: 40%;
  background: white;  
  min-height: 100vh;
}

.navbar-respon > li {
  display:block;
  margin-top: 50px;
  margin-bottom: 25px;  
}

.fixed-normal{
  position: fixed;
  top: -50px;
  z-index: 2;
  margin-top: 50px;
  width: 100%;
  min-height: 61px;
  background: #f0f0f000;
  color: white;
  border-bottom: none;
  left:0px;
}
.normal{
  color:white;
  text-decoration: none;
}

.el-menu-item:hover{
  color:black !important;
  background: white;
}
.inverted{
  color:black !important;
  background: white;
}

.overlay{
  position:fixed;
  min-height: 100vh;
  min-width: 1300px;
  background-color: black;
  opacity: 0.4;
  z-index: 1;
  top:0px;
}

</style>





// WEBPACK FOOTER //
// src/sections/Navbar.vue